//  在store里面的store.js文件写入
import Vue from "vue"
import Vuex from "vuex"
import {IsInSlicer} from "~/utils/studioWXMessage";
Vue.use(Vuex);

export default new Vuex.Store({
    state:{
        // 保存信息的变量名
        userInfo:{},
        userToken: localStorage.getItem('token') || "",
        language:localStorage.getItem('locale') || 'en',
        subject:localStorage.getItem('subject') || "light",
        isInSlicer:false,
        routerUrl:"",
    },
    mutations:{
        // 保存用户所有信息
        saveUserInfo(state,userInfo){
            state.userInfo=userInfo
        },
        // 保存token
        saveUserToken(state,userToken){
            state.userToken = userToken;
            localStorage.setItem('token',userToken)
        },
        // 退出登录清空用户信息
        deleteUserVuex(state){
            state.userInfo={}
            state.userToken = "";
        },
        // 保存language
        setLanguage(state,language){
            state.language = language;
            localStorage.setItem('locale',language)
        },
        // 保存subject
        setSubject(state,subject){
            state.subject = subject==='dark' ? 'dark' : 'light';
            localStorage.setItem('subject',subject)
        },
        // 保存是否在slicer
        setIsinSlicer(state,isInSlicer){
            state.isInSlicer = isInSlicer;
        },
        setRouterUrl(state,routerUrl){
            state.routerUrl = routerUrl;
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js